import { textVariant } from './Text'
import { createStyles } from '@codeleap/styles'
import { SegmentedControlComposition } from '@codeleap/web'
import { StyleRegistry } from '../styles'

const createSegmentedControlVariant = createStyles<SegmentedControlComposition>

const ICON_SEGMENTED_SIZE = 20

export const SegmentedControlStyles = {
  default: createSegmentedControlVariant(theme => ({
    wrapper: {
      height: 'auto',
      width: 'fit-content',
      ...theme.presets.column,
    },
    innerWrapper: {
      borderRadius: theme.radius.regular,
      ...theme.presets.row,
      ...theme.presets.relative,
      height: theme.size.large,
      backgroundColor: theme.baseColors.neutralSolid200,
    },
    text: {
      color: theme.baseColors.primarySolid300,
    },
    'text:selected': {
      color: theme.baseColors.neutralSolid1000,
    },
    'text:disabled': {
      color: theme.baseColors.neutralSolid500,
    },
    icon: {
      ...theme.spacing.marginRight(1),
      color: theme.baseColors.primarySolid300,
      width: theme.values.iconSize[2],
      height: theme.values.iconSize[2],
    },
    'icon:selected': {
      color: theme.baseColors.neutralSolid1000,
    },
    'icon:disabled': {
      color: theme.baseColors.neutralSolid500,
    },
    label: {
      ...theme.spacing.marginBottom(1),
      ...textVariant('p1'),
      color: theme.baseColors.neutralSolid800,
    },
    button: {
      ...theme.presets.alignCenter,
      ...theme.presets.justifyCenter,
      borderRadius: theme.radius.regular,
      minHeight: '100%',
      ...theme.spacing.paddingHorizontal(2),
      cursor: 'pointer',
      zIndex: 1,
      backgroundColor: 'transparent',
    },
    selectedBubble: {
      ...theme.presets.absolute,
      zIndex: 0,
      bottom: 0,
      top: 0,
      backgroundColor: theme.baseColors.primarySolid300,
      borderRadius: theme.radius.regular,
    },
    'innerWrapper:disabled': {
      backgroundColor: 'transparent',
    },
    'selectedBubble:disabled': {
      backgroundColor: 'transparent',
      pointerEvents: 'none',
    },
    'button:disabled': {
      backgroundColor: 'transparent',
      pointerEvents: 'none',
    },
  })),
  tiny: createSegmentedControlVariant(theme => ({
    innerWrapper: {
      height: theme.size.small,
    },
    'button:selected': {
      height: theme.size.small,
    },
    selectedBubble: {
      height: theme.size.small,
      ...theme.spacing.padding(0),
    },
  })),
  small: createSegmentedControlVariant(theme => ({
    innerWrapper: {
      height: theme.size.medium,
    },
    button: {
      borderRadius: theme.radius.regular,
    },
    'button:selected': {
      height: theme.size.medium,
    },
    selectedBubble: {
      height: theme.size.medium,
      ...theme.spacing.padding(0),
    },
  })),
  medium: createSegmentedControlVariant(theme => ({
    innerWrapper: {
      height: theme.size.large,
    },
    button: {
      borderRadius: theme.radius.regular,
    },
    'button:selected': {
      height: theme.size.large,
    },
    selectedBubble: {
      height: theme.size.large,
      ...theme.spacing.padding(0),
    },
  })),
  tinyRadius: createSegmentedControlVariant(theme => ({
    innerWrapper: {
      borderRadius: theme.radius.small,
    },
    button: {
      borderRadius: theme.radius.small,
    },
    'button:selected': {
      borderRadius: theme.radius.small,
    },
    selectedBubble: {
      borderRadius: theme.radius.small,
    },
  })),
  smallRadius: createSegmentedControlVariant(theme => ({
    innerWrapper: {
      borderRadius: theme.radius.regular,
    },
    button: {
      borderRadius: theme.radius.regular,
    },
    'button:selected': {
      borderRadius: theme.radius.regular,
    },
    selectedBubble: {
      borderRadius: theme.radius.regular,
    },
  })),
  rounded: createSegmentedControlVariant(theme => ({
    innerWrapper: {
      borderRadius: theme.radius.infinite,
    },
    button: {
      borderRadius: theme.radius.infinite,
    },
    'button:selected': {
      borderRadius: theme.radius.infinite,
    },
    selectedBubble: {
      borderRadius: theme.radius.infinite,
    },
  })),
  fullWidth: createSegmentedControlVariant(theme => ({
    wrapper: {
      ...theme.presets.fullWidth,
    },
    innerWrapper: {
      ...theme.presets.fullWidth,
    },
    selectedBubble: {
      ...theme.presets.fullWidth,
    },
    button: {
      flex: 1,
    },
    'button:selected': {
      flex: 1,
    },
  })),
  tab: createSegmentedControlVariant(theme => ({
    innerWrapper: {
      backgroundColor: 'transparent',
    },
    'button:selected': {
      backgroundColor: 'transparent',
    },
    selectedBubble: {
      height: theme.size.large,
      backgroundColor: 'transparent',
      borderRadius: 0,
      ...theme.border({
        color: theme.baseColors.primarySolid300,
        directions: ['bottom'],
        width: theme.stroke.medium,
      }),
    },
    'text:selected': {
      color: theme.baseColors.neutralSolid1000,
    },
    text: {
      color: theme.baseColors.neutralSolid900,
      '&:hover': {
        color: theme.baseColors.neutralSolid1000,
      },
    },
    icon: {
      color: theme.baseColors.neutralSolid700,
      width: ICON_SEGMENTED_SIZE,
      height: ICON_SEGMENTED_SIZE,
    },
  })),
}

StyleRegistry.registerVariants('SegmentedControl', SegmentedControlStyles)
